export default "__VITE_ASSET__Fp0dz8Oi__"